module.exports = __webpack_public_path__ + "img/nata-white.1f4d9905.png";